import { ref } from "vue";

export default () => {
  const isOnline = ref(navigator.onLine);

  const checkOnline = () => (isOnline.value = navigator.onLine);

  window.addEventListener("offline", checkOnline);
  window.addEventListener("online", checkOnline);

  return { isOnline };
};
